<template>
  <div class="wallet-connector">
    <div class="set" v-if="!currentWallet" @click="showModal = true">
      <i class="iconfont icon-licai"></i><span>{{ $t("notAnZ") }}</span>
    </div>

    <popover
      v-model="showPopover"
      placement="bottom-end"
      trigger="click"
      theme="dark"
      :actions="actions"
      @select="onSelect"
      v-else
    >
      <template #reference>
        <div class="set">
          <i class="iconfont icon-licai"></i>
          <span>{{ shortenAddress(currentWallet.address) }}</span>
        </div>
      </template>
    </popover>

    <div v-if="showModal" class="wallet-modal">
      <div class="modal-content">
        <div
          v-for="wallet in wallets"
          :key="wallet.info.name"
          @click="connect(wallet.info.uuid)"
          class="wallet-button"
        >
          <div class="left">
            <img
              v-if="wallet.info.icon"
              :src="wallet.info.icon"
              :alt="wallet.info.name"
              class="wallet-icon"
            />
            {{ wallet.info.name }}
          </div>
          <div class="status" v-if="wallet.info.uuid">installed</div>
        </div>
        <div @click="showModal = false" class="cancel">{{ $t("quxiao") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { walletManager } from "../utils/walletManager";
import { Popover } from "vant";
export default {
  data() {
    return {
      showModal: false,
      availableWallets: [],
      currentWallet: null,

      wallets: [
        {
          info: {
            icon: "data:image/svg+xml;base64,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",
            name: "MetaMask",
          },
          provider: null,
        },
        {
          info: {
            icon: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJDSURBVHgB7Zq9jtpAEMfHlhEgQLiioXEkoAGECwoKxMcTRHmC5E3IoyRPkPAEkI7unJYmTgEFTYwA8a3NTKScLnCHN6c9r1e3P2llWQy7M/s1Gv1twCP0ej37dDq9x+Zut1t3t9vZjDEHIiSRSPg4ZpDL5fxkMvn1cDh8m0wmfugfO53OoFQq/crn8wxfY9EymQyrVCqMfHvScZx1p9ls3pFxXBy/bKlUipGPrVbLuQqAfsCliq3zl0H84zwtjQrOw4Mt1W63P5LvBm2d+Xz+YzqdgkqUy+WgWCy+Mc/nc282m4FqLBYL+3g8fjDxenq72WxANZbLJeA13zDX67UDioL5ybXwafMYu64Ltn3bdDweQ5R97fd7GyhBQMipx4POeEDHIu2LfDdBIGGz+hJ9CQ1ABjoA2egAZPM6AgiCAEQhsi/C4jHyPA/6/f5NG3Ks2+3CYDC4aTccDrn6ojG54MnEvG00GoVmWLIRNZ7wTCwDHYBsdACy0QHIhiuRETxlICWpMMhGZHmqS8qH6JLyGegAZKMDkI0uKf8X4SWlaZo+Pp1bRrwlJU8ZKLIvUjKh0WiQ3sRUbNVq9c5Ebew7KEo2m/1p4jJ4qAmDaqDQBzj5XyiAT4VCQezJigAU+IDU+z8vJFnGWeC+bKQV/5VZ71FV6L7PA3gg3tXrdQ+DgLhC+75Wq3no69P3MC0NFQpx2lL04Ql9gHK1bRDjsSBIvScBnDTk1WrlGIZBorIDEYJj+rhdgnQ67VmWRe0zlplXl81vcyEt0rSoYDUAAAAASUVORK5CYII=",
            name: "OKX Wallet",
          },
          provider: null,
        },
        // {
        //   info: {
        //     icon: "data:image/png;base64,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",
        //     name: "Gate Wallet",
        //   },
        //   provider: null,
        // },
      ],
      showPopover: false,
      actions: [{ text: this.$t('logout'), value: "1" }],
    };
  },
  components: { Popover },
  async created() {
    window.addEventListener(
      "walletManager:providersChanged",
      this.updateWalletList
    );
    this.updateWalletList();
    await walletManager.checkIfConnected();
    this.currentWallet = walletManager.currentWallet;
    this.updateWalletList();
  },

  beforeDestroy() {
    window.removeEventListener(
      "walletManager:providersChanged",
      this.updateWalletList
    );
  },

  methods: {
    updateWalletList() {
      const availableWallets = Array.from(walletManager.providers.values());
      this.wallets.forEach((wallet) => {
        const matched = availableWallets.find(
          (available) => available.info.name === wallet.info.name
        );
        if (matched) {
          wallet.info = matched.info;
          // wallet.provider = matched.provider;
        }
      });
    },

    async connect(uuid) {
      try {
        this.currentWallet = await this.$wallet.connectWallet(uuid);
        this.showModal = false;
        this.$emit("connected", this.currentWallet);
      } catch (error) {
        this.$emit("error", error);
      }
    },

    disconnect() {
      if (this.currentWallet) {
        this.$wallet.disconnectWallet(this.currentWallet.uuid);
        this.currentWallet = null;
        this.$emit("disconnected");
      }
    },

    handleAccountsChanged(accounts) {
      if (accounts.length === 0) {
        this.disconnect();
      }
    },

    shortenAddress(address) {
      if (!address) return "";
      return `${address.slice(0, 5)}...${address.slice(-4)}`;
    },
    onSelect(action) {
      this.disconnect();
    },
    handleCommand(e) {
      const that = this;
      switch (e) {
        case "routeUser":
          that.routeUser();
          break;
        case "disconnectMetaMask":
          that.disconnect();
          break;
        default:
          break;
      }
    },
    routeUser() {
      console.log("object");
      this.$router.push("/user");
    },
  },
};
</script>

<style scoped lang="scss">
.connect {
  border-radius: 10px 10px 10px 10px;
  width: 147px;
  height: 38px;
  color: #000;
  text-align: center;
  line-height: 38px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 20px;
    height: 20px;
  }
}
.wallet-connector {
  position: relative;
  display: flex;
  align-items: center;
}

.wallet-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  height: 100vh;
}

.modal-content {
  background: rgba(255, 255, 255);
  backdrop-filter: blur(30px);
  border-radius: 15px;
  padding: 20px;
  max-width: 500px;
  width: 100%;
}
.wallet-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
  cursor: pointer;
  padding: 0 10px;
  &:hover {
    background: rgba(1, 1, 1, 0.1) !important;
  }
  .left {
    display: flex;
    align-items: center;
    font-size: 26px;
  }
  &:first-child {
    border-bottom: 1px solid #eee;
  }
}
.status {
  color: #999;
  font-size: 26px;
}
.cancel {
  height: 70px;
  background-color: #333;
  border-radius: 16px;
  text-align: center;
  line-height: 70px;
  margin-top: 20px;
  cursor: pointer;
  color: #fff;
}
.wallet-icon {
  width: 50px;
  height: 50px;
  margin-right: 20px;
}

.connected-wallet {
  display: flex;
  align-items: center;
  gap: 8px;
}

.wallet-address {
  font-family: monospace;
}
.set {
  border-radius: 18px;
  opacity: 1;
  display: flex;
  align-items: center;
  padding: 4px 15px;
  box-sizing: border-box;
  font-size: 26px;
  cursor: pointer;
  color: #000;
  border: 1px solid #999;

  i {
    margin-right: 10px;
    font-size: 28px;
  }
}
</style>
